<template>
    <custom-modal title="Asset Belongs To" v-model="show" :loading="loading" @close="close()">
        <div v-if="item.message">{{ item.message }}</div>
        <div v-else>
            <v-card v-if="item.station && item.station.assignable_asset">
                <v-card-title>Asset Details</v-card-title>
                <v-card-text>
                    <div><strong>Inventory Number:</strong> {{ item.station.assignable_asset.inventory_number }} </div>
                    <div><strong>Inventory Name:</strong> {{ item.station.assignable_asset.name_eng }} </div>
                </v-card-text>
            </v-card>

            <v-card class="mt-3" v-if="item.station && item.station.station && item.staff && item.staff.assignable_staff">
                <v-card-title>Assignment Details</v-card-title>
                <v-card-text>
                    <div><strong>Station:</strong> {{ item.station.station.label }}</div>
                    <div>
                        <strong>Staff:</strong> 
                        <v-list-item-avatar size="30" class="mr-2">
                            <v-img :src="item.staff.assignable_staff.profile_url"></v-img>
                        </v-list-item-avatar>
                        {{ item.staff.label }}
                    </div>
                </v-card-text>
            </v-card>
        </div>
    </custom-modal>
</template>

<script>
import axios from '../../plugins/axios'
import CustomModal from '../util/CustomModal.vue'

export default {
    components: {CustomModal},
    data: () => ({
        loading: false,
        item: {},
        show: false,
    }),
    methods: {
        open(inv_no) {
            this.loading = true
            axios.get(`/api/office-assets/getAssetBelongsTo?inventory_number=${inv_no}`).then((resp) => {
                this.item = resp.data
                this.show = true
            }).finally(() => this.loading = false)
        },
        close() {
            this.$emit('reload')
            this.resetData()
        },
        resetData() {
            Object.assign(this.$data, this.$options.data())
        },
    }
}
</script>

<style>

</style>